import React from "react"
import { Checkbox, ControlLabel, FormGroup, Radio } from "react-bootstrap"


export default function Question(props) {
  // PROPS
  const {
    question,
    selectedAnswer,
    selectAnswer,
    assessmentSubmitted,
    submittingAssessment,
    wrongAnswers,
    missedQuestion
  } = props

  const getValidationState = () => {
    if (missedQuestion) return "warning"

    if (!assessmentSubmitted) return null
    if (wrongAnswers) return "error"
    else return "success"
  }

  const generateOption = (option) => {
    if (question.type === "Multiselect") {
      return (
        <div className="option">
          <Checkbox
            key={ option.id }
            value={ option.id }
            selected={ selectedAnswer === option.id }
            onChange={ (e) => selectAnswer(question, e.target.value) }
            disabled={ assessmentSubmitted || submittingAssessment }
          >
            { option.name }
          </Checkbox>
        </div>
      )
    } else {
      return (
        <div className="option">
          <Radio
            key={ option.id }
            value={ option.id }
            name={ question.id }
            selected={ selectedAnswer === option.id }
            onChange={ (e) => selectAnswer(question, e.target.value) }
            disabled={ assessmentSubmitted || submittingAssessment }
          >
            { option.name }
          </Radio>
        </div>
      )
    }
  }

  let suffix = null

  if (question.type === "Multiselect") {
    suffix = " - Choose all the correct answers"
  } else if (question.type === "Boolean") {
    suffix = " - True (or) False?"
  }

  return (
    <FormGroup
      className="question"
      validationState={ getValidationState() }
    >
      <ControlLabel>
        { question.name } { suffix }
      </ControlLabel>
      { question.options.map(generateOption) }
    </FormGroup>
  )
}



// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTraining/Assessment/Question.js